"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicSSO = void 0;
const useAuth0_1 = require("../hooks/useAuth0");
const utils_1 = require("../../utils");
const react_1 = __importDefault(require("react"));
function DynamicSSO(props) {
    const { authConfig, theme, disableSSORegex, nonSSOConnections } = props;
    const [email, setEmail] = react_1.default.useState("");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let noSSOParam = false;
    urlParams.forEach((value, key) => {
        if (key.toLowerCase() === "nosso") {
            noSSOParam = true;
        }
    });
    const [useSSO, setUseSSO] = react_1.default.useState(!noSSOParam);
    const handler = (event) => {
        const currentEmail = `${event.target.value}`;
        if (currentEmail && currentEmail.toLowerCase().match(disableSSORegex)) {
            if (useSSO) {
                setTimeout(() => {
                    const input = document.querySelector("input[type=password]");
                    input && input.focus();
                }, 1500);
                setEmail(currentEmail);
                setUseSSO(false);
            }
        }
        else if (!useSSO && !noSSOParam) {
            setEmail(currentEmail);
            setUseSSO(true);
        }
    };
    const emailField = utils_1.useWaitForElement("input[type=email]", el => {
        el.addEventListener("change", handler);
    }, () => {
        emailField &&
            emailField.current &&
            emailField.current.removeEventListener("change", handler);
    }, 1000);
    return useSSO ? (react_1.default.createElement(useAuth0_1.AuthProvider, { audience: authConfig.audience, domain: authConfig.domain, clientId: authConfig.clientId, redirectFromLoginUrl: authConfig.redirect_uri, allowedConnections: authConfig.allowed_connections, theme: theme, defaultEmail: email },
        react_1.default.createElement(react_1.default.Fragment, null, props.children))) : (react_1.default.createElement(useAuth0_1.AuthProvider, { audience: authConfig.audience, domain: authConfig.domain, clientId: authConfig.clientId, redirectFromLoginUrl: authConfig.redirect_uri, allowedConnections: nonSSOConnections, theme: theme, defaultEmail: email },
        react_1.default.createElement(react_1.default.Fragment, null, props.children)));
}
exports.DynamicSSO = DynamicSSO;
//# sourceMappingURL=DynamicSSO.js.map